import CardWidgetStyled from "./styled-components/CardWidgetStyled";

export default function CardWidget(props) {
  return <CardWidgetStyled src={props.icon} />;
}
